<div *ngIf="(loading$ | async) else messageEditor" class="tw-flex tw-flex-col tw-items-center tw-w-full tw-pr-2">
    <mat-progress-spinner  [color]="'primary'" [diameter]="50" mode="indeterminate" ></mat-progress-spinner>
    <div class="tw-mt-8 tw-pb-3.5">Loading Email Templates</div>
</div>
<ng-template #messageEditor>
  <div class="tw-p-5">
    <div appDragonDrop (FileDropped)="uploadFile($event)" *ngIf="signature && (templates$ | async)">
        <app-alert *ngIf="documentAlert"
            [level]="documentAlert.level"
            [message]="documentAlert.message"
            (dismissed)="dismissDocumentAlert()">
        </app-alert>
        <form [formGroup]="emailForm">
            <div class="tw-grid">
              <mat-form-field floatLabel="always">
                <mat-chip-grid #toChipList>
                  <mat-chip
                    *ngFor="let email of toEmailControl; let i = index"
                    [removable]="removable"
                    (removed)="removeRecipient(email, 'to')"
                  >
                    {{ email }}
                    <mat-icon matChipRemove (click)="removeRecipient(email, 'to')">cancel</mat-icon>
                  </mat-chip>
                  <input
                    #toEmailInput
                    formControlName="toEmail"
                    (keyup)="emailSuggestions($event, 'toEmail')"
                    [matChipInputFor]="toChipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addToEmailAddress($event)"
                    [matAutocomplete] = "toAuto"
                    data-cy="email-to-input">
                </mat-chip-grid>
                <mat-label>To:</mat-label>
                <mat-autocomplete #toAuto="matAutocomplete" (optionSelected)="addThisEmailFromOptions($event)">
                  <mat-option *ngFor="let email of suggestedEmails" [value]="email">
                    {{ email.email }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <div *ngIf='!addBCC' class="tw-mb-4">
                <small><a data-cy="email-bcc-input" class="tw-cursor-pointer" (click)='addBCCRecipient(); populateBcc();'>BCC</a></small>
              </div>
              <mat-form-field *ngIf='addBCC'>
                <mat-chip-grid #bccChipList>
                  <mat-chip
                    *ngFor="let email of bccEmailControl; let i = index"
                    [removable]="removable"
                    (removed)="removeRecipient(email, 'bcc')"
                  >
                    {{ email }}
                    <mat-icon matChipRemove (click)="removeRecipient(email, 'bcc')">cancel</mat-icon>
                  </mat-chip>
                  <input
                    #bccEmailInput
                    formControlName="bccEmail"
                    (keyup)="emailSuggestions($event, 'bccEmail')"
                    [matChipInputFor]="bccChipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addBccEmailAddress($event)"
                    [matAutocomplete] = "bccAuto"
                  >
                </mat-chip-grid>
                <mat-label>BCC</mat-label>
                <mat-autocomplete #bccAuto="matAutocomplete" (optionSelected)="addThisBCCEmailFromOptions($event)">
                  <mat-option *ngFor="let email of suggestedEmails" [value]="email">
                    {{ email.email }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field *ngIf="showSubjectField" #matFormFieldSubject>
                <mat-label>Subject</mat-label>
                <input matInput formControlName="subject">
              </mat-form-field>
            </div>
        </form>
      <quill-editor
          format="html"
          class="tw-w-full"
          [placeholder]='placeholder'
          [(ngModel)]="content"
          (onEditorCreated)="handleEditorCreated($event)"
          (onSelectionChanged)="handleSelectionChange($event.range)"
          (onContentChanged)="handleContentChange()"
          (keydown.enter)="handleEnterSelectionLocation()">
        <div quill-editor-toolbar id="tool-container">
          <app-message-signature [signature]="signature"></app-message-signature>
          <div class="tw-mt-4 column-grid tw-grid-cols-[1fr_auto_0] tw-place-items-center">
            <div class="column-grid tw-gap-2 tw-justify-self-start tw-place-items-center">
              <button mat-button matTooltip="Bold Text" id="quill-buttons" class="ql-bold"></button>
              <button mat-button matTooltip="Italic Text" id="quill-buttons" class="ql-italic"></button>
              <button mat-button matTooltip="Ordered List" id="quill-buttons" class="ql-list" value="ordered"></button>
              <button mat-button matTooltip="Bullet List" id="quill-buttons" class="ql-list" value="bullet"></button>
              <button data-cy="email-attachment-btn" class="message-add-attachment" mat-button [matMenuTriggerFor]="attachmentHandler" matTooltip="Add Attachment">
                <svg xmlns="http://www.w3.org/2000/svg" class="message-attachment-icon" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12.5 23c3.04 0 5.5-2.46 5.5-5.5V6h-1.5v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5z"/></svg>
                <mat-menu class="message-attachment-mat-menu" #attachmentHandler>
                  <button class="link-list" mat-menu-item
                          (click)="fileInput.click()">
                    <a class="link-list-items">Computer</a>
                  </button>
                  <input #fileInput
                         type="file"
                         (change)="uploadDocuments($event.target.files)"
                         multiple/>
                  <button class="link-list link-list-items" mat-menu-item>
                    <app-document-picker
                      [borrower]="borrower"
                      (selectedFile)="onFileChange($event)">
                    </app-document-picker>
                  </button>
                </mat-menu>
              </button>
              <app-template-picker *ngIf="(templates$ | async) && (opportunity$ | async) as opportunity"
                                   [affiliateId]='opportunity?.marketing?.affiliateId'
                                   [templates]='templates$ | async'
                                   [selectedTemplate]='selectedTemplate'
                                   (chooseTemplate)="chooseTemplate($event)">
              </app-template-picker>
              <!-- Removed due to legal concerns.  Add back once concerns/fix can be scoped. -->
              <button mat-button
                      data-cy="email-template-btn"
                      class="tw-whitespace-nowrap !tw-w-fit"
                      id="add-message-link"
                      [matMenuTriggerFor]="linkHandler"
                      (click)="getLinks()">
                Add Link
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
              <mat-menu #linkHandler>
                <button class="link-list" mat-menu-item *ngFor="let link of links">
                  <a class="link-list-items tw-text-black" (click)="handleInsertLink(link)">{{ link.label }}</a>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </quill-editor>
      <mat-progress-bar *ngIf="files.length" mode="indeterminate"></mat-progress-bar>
      <div *ngIf="documents.length || files.length">
        <mat-chip-grid #documentsChips>
          <mat-chip class="message-attachments" *ngFor="let document of documents; let i = index">
            {{ document.title }}
            {{ document.size | bytes }}
            <mat-icon matChipRemove (click)="documents.splice(i, 1)">cancel</mat-icon>
          </mat-chip>
          <mat-chip class="message-attachments" *ngFor="let file of files">
            {{ file.name }}
          </mat-chip>
        </mat-chip-grid>
      </div>
    </div>
  <div class="tw-mt-4 column-grid tw-justify-end tw-gap-2">
    <button
      mat-button
      [color]="'primary'"
      (click)="previewMessage()">
      Preview
    </button>
    <button mat-button class="cancel-message" (click)="handleCancelMessage()" data-cy="email-cancel-btn">Cancel</button>
    <button
      *ngIf="!messageType && content"
      mat-raised-button
      class="send-message"
      [ngClass]="{'send-message-truthy': content && content.trim().length}"
      [disabled]="sendButtonDisabled || !content.trim().length || !toEmailControl.length || this.changeCount < 1"
      (click)="sendMessage()"
      data-cy="email-send-btn"
      id="send-key-command"
    >Send</button>
    <button
      *ngIf="messageType === 'reply' && content"
      mat-raised-button
      class="send-message"
      [ngClass]="{'send-message-truthy': content && content.trim().length}"
      [disabled]="sendButtonDisabled || !content.trim().length || !toEmailControl.length || this.changeCount < 1"
      (click)="sendMessage()"
      data-cy="email-reply-btn"
      id="send-key-command"
    >Reply</button>
    <button
      *ngIf="messageType === 'forward' && content"
      mat-raised-button
      class="send-message-forward"
      [ngClass]="{'send-message-truthy': content && content.trim().length}"
      [disabled]="sendButtonDisabled || !content.trim().length || !toEmailControl.length || this.changeCount < 1"
      (click)="sendMessage()"
      id="send-key-command"
    >Forward</button>
  </div>
  </div>
</ng-template>
